import { IonActionSheet } from '@ionic/react';
import React from 'react';

import { CameraActionSheetProps } from './types';

const CameraActionSheet: React.FC<CameraActionSheetProps> = ({
  showCameraOptions,
  setShowCameraOptions,
  takePhoto,
  selectFromGallery,
  uploadPDF,
}) => {
  return (
    <IonActionSheet
      isOpen={showCameraOptions}
      onDidDismiss={() => setShowCameraOptions(false)}
      buttons={[
        {
          text: '📸 Tomar Foto',
          handler: () => {
            setShowCameraOptions(false);
            takePhoto();
          },
        },
        {
          text: '🖼️ Seleccionar Imagen',
          handler: () => {
            setShowCameraOptions(false);
            selectFromGallery();
          },
        },
        ...(uploadPDF
          ? [
              {
                text: '📄 Seleccionar PDF',
                handler: () => {
                  setShowCameraOptions(false);
                  uploadPDF();
                },
              },
            ]
          : []),
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => setShowCameraOptions(false),
        },
      ]}
    />
  );
};

export default React.memo(CameraActionSheet);
